import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { GetClientsDetail } from '../store/slices/auth';
import { UpdateCashOpeningBalance, LedgerEntires } from '../store/slices/bankbook';
import Table from '../common/Table';
import { toast } from 'react-hot-toast';
import Loader from '../common/Loader';
import AdminLayout from './AdminLayout';
import { FaFileExcel } from "react-icons/fa";
import {excelCashBookDownload } from "../common/ExcelDownload";
import { FaFilePdf } from "react-icons/fa";
import { API_BASE_URL, API_PATHS } from '../utils/constants/api.constants';

const CashBook = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const tableRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user'));
  const id = user?.data?.profile_id;

  const [currentDate, setCurrentDate] = useState('');
  const [isLoading, setIsLoading] = useState(false);
    const [selectedRows, setSelectedRows] = useState([]);  // Stores selected row IDs
    const [selectAll, setSelectAll] = useState(false);
  const [columns, setcolumns] = useState([
    { header: 'Checkbox', field: 'Checkbox' },
    { header: 'Type', field: 'type' },
    { header: 'Description', field: 'description', isMultiline: true },
    { header: 'Date', field: 'ledger_date' },
    { header: 'Dr', field: 'dr', isDrCr: true, isDr: true },
    { header: 'Cr', field: 'cr', isDrCr: true, isDr: false },
    { header: 'Closing Balance', field: 'balance' },
  ]);

  const [ledgerEntires, setLedgerEntires] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(25);
  const [searchQuery, setSearchQuery] = useState('');

  const [formData, setFormData] = useState({
    id: id,
    cash_opening_balance: '',
    cash_opening_balance_date: '',
  });

  const [errors, setErrors] = useState({});
  const [item, setItem] = useState({
    ledger_id: 1,
    profile_id: id,
  });


 // Load saved financial year and dates from localStorage
const loadSavedDates = () => {
  const savedFinancialYear = localStorage.getItem('selectedFinancialYear');
  
  // Ensure financial year is always correctly structured
  let startYear, endYear;
  if (savedFinancialYear && savedFinancialYear.includes('-')) {
    [startYear, endYear] = savedFinancialYear.split('-');
  } else {
    // Default to the current financial year
    const currentYear = new Date().getFullYear();
    startYear = currentYear - 1; // Example: 2024 (for 2024-2025)
    endYear = currentYear;       // Example: 2025 (for 2024-2025)
  }

  return {
    financialYear: savedFinancialYear || `${startYear}-${endYear}`,
    fromDate: localStorage.getItem('savedFromDate') || `${startYear}-04-01`,
    toDate: localStorage.getItem('savedToDate') || `${endYear}-03-31`,
    minDate: `${startYear}-04-01`,
    maxDate: `${endYear}-03-31`,
  };
};


const { fromDate: initialFromDate, toDate: initialToDate, minDate, maxDate, financialYear: initialFinancialYear } = loadSavedDates();

const [fromDate, setFromDate] = useState(initialFromDate);
const [toDate, setToDate] = useState(initialToDate);
const [financialYear, setFinancialYear] = useState(initialFinancialYear);


useEffect(() => {
  if (!financialYear) return;

  localStorage.setItem('selectedFinancialYear', financialYear);

  let startYear, endYear;
  if (financialYear.includes('-')) {
    [startYear, endYear] = financialYear.split('-');
  } else {
    return; // Exit if financial year is not valid
  }

  const savedFromDate = localStorage.getItem('savedFromDate') || `${startYear}-04-01`;
  const savedToDate = localStorage.getItem('savedToDate') || `${endYear}-03-31`;

  setFromDate(savedFromDate);
  setToDate(savedToDate);

  if (!localStorage.getItem('savedFromDate')) localStorage.setItem('savedFromDate', savedFromDate);
  if (!localStorage.getItem('savedToDate')) localStorage.setItem('savedToDate', savedToDate);
}, [financialYear]);


const today = new Date();
const formattedDate = today.toISOString().split('T')[0];

  useEffect(() => {
    fetchClientDetails();
    // Get the current date
    handleLedgerClick();
    // Set date and date_as_of to the current date in formData
    setFormData((prevData) => ({
      ...prevData,
      cash_opening_balance_date: formattedDate,
    }));
  }, [financialYear]);

  const handleLedgerClick = async (e) => {
    if (e) e.preventDefault(); // Prevent default only if `e` is present

    const newItem = {
      ...item,
      ledger_id: 1,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };
    setItem(newItem);

    const requestId = Date.now();
    const currentRequestId = requestId;
    setIsLoading(true);

    try {
      const data = await dispatch(LedgerEntires(newItem)).unwrap();

      if (currentRequestId === requestId) {
        setLedgerEntires(data?.data?.entries || []);
      }
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };


  const resetDates = async () => {
    const storedFinancialYear = localStorage.getItem('selectedFinancialYear'); // Example: "2022-2023"
    
    let startYear, endYear;
    
    if (storedFinancialYear) {
      // Extract the start and end year from stored financial year
      [startYear, endYear] = storedFinancialYear.split('-');
    } else {
      // If not found, determine the current financial year dynamically
      const today = new Date();
      startYear = today.getMonth() + 1 >= 4 ? today.getFullYear() : today.getFullYear() - 1;
      endYear = parseInt(startYear) + 1;
    }
  
    const defaultFromDate = `${startYear}-04-01`;
    const defaultToDate = `${endYear}-03-31`;
  console.log(defaultFromDate,defaultToDate)
    // Update state
    setFromDate(defaultFromDate);
    setToDate(defaultToDate);
  
   localStorage.setItem('savedFromDate', defaultFromDate);
   localStorage.setItem('savedToDate', defaultToDate);
    // Create newItem with updated financial year

    // Call handleProfitLoss with updated values directly
    const newItem = {
      ...item,
      ledger_id: 1,
      from_date: fromDate, // Ensure from_date is sent
      to_date: toDate, // Ensure to_date is sent
    };

    setIsLoading(true);

    try {
      const data = await dispatch(LedgerEntires(newItem)).unwrap();

      if (data) {
        setLedgerEntires(data?.data?.entries || []);
      }
    } catch (error) {
      toast.error('No Record Found!!');
      console.log(error.message);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const fetchClientDetails = async () => {
    try {
      const data = await dispatch(GetClientsDetail({ id: id })).unwrap();
      setFormData((prevData) => ({
        ...prevData,
        cash_opening_balance: data?.user?.data?.cash_opening_balance || 0,
        cash_opening_balance_date: data?.user?.data?.cash_opening_balance_date || formattedDate,
      }));
    } catch (error) {
      console.log('Error fetching ClientDetails:', error.message);
    }
  };

   const handlePDF = (item) => {
      const data = `${API_BASE_URL}${API_PATHS.pdfCashBook}/${fromDate}/${toDate}/${id}/1`;
      navigate('/Pdf-Viewer', { state: { data } });
    };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'cash_opening_balance') {
      // Allow only numbers with 2 decimal places
      if (/^\d*\.?\d{0,2}$/.test(value)) {
        setFormData((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
      setFormData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // const handleDiscard = () => {
  //   setFormData({
  //     id: id,
  //     cash_opening_balance: '',
  //     cash_opening_balance_date: currentDate,
  //   });
  // };

  // const validate = () => {
  //   let newErrors = {};
  //   if (!formData.cash_opening_balance || parseFloat(formData.cash_opening_balance) <= 0) newErrors.cash_opening_balance = 'Please enter a valid amount greater than 0.';
  //   setErrors(newErrors);
  //   return Object.keys(newErrors).length === 0;
  // };

  // console.log("formData",formData,currentDate)
  // const handleSubmit = async (e) => {
  //   e.preventDefault();
  //   if (validate()) {
  //     setIsLoading(true);
  //     dispatch(UpdateCashOpeningBalance(formData))
  //       .unwrap()
  //       .then((data) => {
  //         setIsLoading(false);
  //         setFormData({
  //           id: id,
  //           cash_opening_balance: '',
  //           cash_opening_balance_date: currentDate,
  //         });
  //         fetchClientDetails();
  //         navigate('/');
  //       })
  //       .catch(({ message }) => {
  //         setIsLoading(false);
  //         console.log(message);
  //       });
  //   }
  // };

  const filteredledgerEntires = (ledgerEntires || [])?.filter((party) => {
    const search = searchQuery?.toLowerCase() || '';
    return (
      party?.type?.toLowerCase()?.includes(search) ||
      party?.description?.toLowerCase()?.includes(search) ||
      party?.added_on?.toLowerCase()?.includes(search) ||
      String(party?.dr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.cr || '')
        .toLowerCase()
        .includes(search) || // Safely convert to string
      String(party?.balance || '')
        .toLowerCase()
        .includes(search) // Safely convert to string
    );
  });

      const handleExcelDownload = () => {
        if (!ledgerEntires || ledgerEntires.length === 0) {
            alert("No data available for download.");
            return;
        }
    
        const selectedInvoices = selectAll && ledgerEntires.length > 0
            ? ledgerEntires.map(invoice => invoice.id)
            : selectedRows;
    
        if (!selectedInvoices || selectedInvoices.length === 0) {
            alert("Please select at least one CashBook.");
            return;
        }
    
        const selectedData = ledgerEntires.filter(invoice => selectedInvoices.includes(invoice.id));
    
        if (selectedData.length === 0) {
            alert("No matching CashBook found.");
            return;
        }
    
        try {
          excelCashBookDownload(selectedData, "CashBook.xlsx");
            toast.success("Downloading Excel file successfully!");
        } catch (error) {
            console.error("Error downloading Excel file:", error);
            alert("Failed to download the Excel file. Please try again.");
        }
    };


    const handleFromDateChange = (e) => {
      const newDate = e.target.value;
      if (newDate >= minDate && newDate <= maxDate) {
        setFromDate(newDate);
        localStorage.setItem('savedFromDate', newDate);
      } else {
           toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
      }
    };
    
    const handleToDateChange = (e) => {
      const newDate = e.target.value;
      if (newDate >= minDate && newDate <= maxDate) {
        setToDate(newDate);
        localStorage.setItem('savedToDate', newDate);
      } else {
           toast.error(`Select a date within the financial year ${formatFinancialYear(minDate, maxDate)}`);
      }
    };
    const formatFinancialYear = (startDate, endDate) => {
      return `(${startDate.split("-").reverse().join("-")} to ${endDate.split("-").reverse().join("-")})`;
    };
  return (
    <AdminLayout>
      {isLoading && <Loader />}
      <div className="row content-body">
        <div className="container">
          <div className="page-header">
            <div>
              <h2 className="main-content-title tx-24 mg-b-5">Cash Book</h2>
              <ol className="breadcrumb">
                <li className="breadcrumb-item">
                  <a href="#">Cash Book</a>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  Cash Book
                </li>
              </ol>
            </div>
             <div className="d-flex justify-content-end">
              </div>
          </div>
          {/* <div className="row">
            <div className="col-md-8">
              <div className="card custom-card">
                <div className="card-body">
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-6">
                        <label>
                          Opening Balance <span className="required">*</span>
                        </label>
                        <input name="cash_opening_balance" type="text" className="form-control" onChange={handleInputChange} value={Number(formData?.cash_opening_balance) || 0.0} />
                        {errors?.cash_opening_balance && <span className="alert-message">{errors?.cash_opening_balance}</span>}
                      </div>
                      <div className="col-md-6">
                        <label>
                          Date <span className="required">*</span>
                        </label>
                        <input name="cash_opening_balance_date" type="date" className="form-control" onChange={handleInputChange} value={formData?.cash_opening_balance_date || currentDate} />
                      </div>
                    </div>
                  </div>
                  <div className="form-group">
                    <div className="row">
                      <div className="col-md-6">
                        <button type="button" className="btn btn-default" onClick={handleSubmit}>
                          Submit
                        </button>
                        &nbsp;
                        <button type="button" className="btn btn-cancel" onClick={handleDiscard}>
                          Cancel
                        </button>
                        &nbsp;
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row mt-4 mb-4">
            <div className="col-md-12">
              <div class="row">
                <div class="col-md-12">
                  <div class="card custom-card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">From Date</label>
                            <input class="form-control" type="date" value={fromDate} onChange={handleFromDateChange} min={minDate} max={maxDate} />
                          </div>
                        </div>
                        <div class="col-md-3 form-inline">
                          <div class="form-group">
                            <label class="">To Date</label>
                            <input class="form-control" type="date" value={toDate} onChange={handleToDateChange} min={minDate} max={maxDate} />
                          </div>
                        </div>
                        <div class="col-md-6 form-inline">
                          <div class="form-group">
                            <button type="submit" class="btn btn-default" onClick={() => handleLedgerClick()}>
                              Submit
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" className="btn btn-default" onClick={resetDates}>
                              Reset Date
                            </button>
                          </div>
                          <div class="form-group">
                            <button type="button" className="btn btn-default" onClick={handlePDF}>
                              Export <FaFilePdf />
                            </button>
                          </div>
                          <div lass="form-group">
                              <button className="btn ripple btn-default"   onClick={handleExcelDownload} >
                                Export Excel <FaFileExcel/>
                              </button>
                          </div>
                          
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="card custom-card">
                <div className="card-body">
                  <div className="row mt-3">
                    <div className="col-md-12">
                      <div class="row mt-3">
                        <div class="col-md-12">
                          <Table
                            columns={columns}
                            data={filteredledgerEntires}
                            tableRef={tableRef}
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            currentPage={currentPage}
                            totalCount={filteredledgerEntires?.length}
                            onPageChange={handlePageChange}
                            handleSearchChange={handleSearchChange}
                            handleSubmit={handleLedgerClick}
                            selectedRows={selectedRows}
                            setSelectedRows={setSelectedRows} 
                            selectAll={selectAll} 
                             setSelectAll={setSelectAll} 
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AdminLayout>
  );
};

export default CashBook;
